import { SET_CALENDAR_EVENTS } from '../actionConstants';

const defaultState = [];

export default (state = defaultState, action) => {
  const { type, events } = action;
  switch (type) {
    case SET_CALENDAR_EVENTS:
      return events;
    case '@@router/LOCATION_CHANGE':
      return defaultState;
    default:
      return state;
  }
};
